import {
    InputType,
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { CosteModel } from 'src/app/models/coste.model';
import { environment } from 'src/environments/environment';

export class CostesProductosFormDefinition {
    public formType!: FormType;

    public formFields!: Form<CosteModel>;

    public fieldNames: FormField<CosteModel>[] = [];

    public fieldLabels: string[] = [];

    constructor(type: FormType = FormType.INFORMATIVE) {
        this.formType = +type;

        this.formFields = {
            name: 'costes-productos',
            header: 'Detalle del registro',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<CosteModel>[] {
        return [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getMainFields(),
                order: 1,
            },
        ];
    }

    private getMainFields(): FormField<CosteModel>[] {
        const fields: FormField<CosteModel>[] = [
            this.textField('fecha', 'Fecha', 1),
            this.textField('finca_nombre', environment.features.fincaName, 2),
            this.textField('parcela_nombre', environment.features.parcelaName, 3),
            this.textField('tipo_producto', 'Tipo', 4),
            this.textField('nombre', 'Producto', 5),
            this.textField('unidades', 'Cantidad', 6),
            this.textField('precio', 'Precio', 7),
            this.textField('resultado', 'Resultado', 8),
        ];

        return this.registerVisibleFields(fields);
    }

    private textField(name: string, label: string, order: number, isVisible = true): FormField<CosteModel> {
        return {
            name,
            vinculatedFields: undefined,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
            },
            width: 3,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }

    private registerVisibleFields(fields: FormField<CosteModel>[]): FormField<CosteModel>[] {
        for (const field of fields) {
            if (field.conditions.isVisible) {
                this.fieldNames.push(field);
                this.fieldLabels.push(field.label);
            }
        }

        return fields.sort((a, b) => a.order - b.order);
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}
